import { render, staticRenderFns } from "./DptTool.vue?vue&type=template&id=1ae870bb&scoped=true"
import script from "./DptTool.vue?vue&type=script&lang=js"
export * from "./DptTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae870bb",
  null
  
)

export default component.exports